export const eventsQueryVarsArgs = {
    vars: `
    $offset: Int
    $limit: Int
    $keyword: String
    $disciplineIds: [ID]
    $competitionLevelIds: [ID]
    $regionIds: [ID]
    $eventIds: [ID]
    $organiserIds: [ID]
    $place: String
    $statuses: [String]
    $endDateFrom: String
    $registrationEndDateUntil: String
    $sortBy: String
    $sortDesc: Boolean
    $cupIds: [ID]
    $walletStatuses: [String]
    $useEquipe: Boolean
    $noncompetition: Boolean
    $eventCategoryIds: [ID]
    $profQualificationIds: [ID]
    $countryIds: [ID]

    $isHighlighted: Boolean
    $hasTeamCompetitions: Boolean
    $hasChampionshipCompetitions: Boolean

    $hasEntries: Boolean
    $hasAcceptedEntries: Boolean
    $hasCandidacyEntries: Boolean

    $closingSoon: Boolean
    $recentlyOpened: Boolean

    $noPeopleAssignedInRoleIds: [ID]
    $personRoleFilter: PersonRoleFilterInput
  `,
    args: `
    offset: $offset
    limit: $limit
    keyword: $keyword
    disciplineIds: $disciplineIds
    competitionLevelIds: $competitionLevelIds
    regionIds: $regionIds
    eventIds: $eventIds
    organiserIds: $organiserIds
    place: $place
    statuses: $statuses
    endDateFrom: $endDateFrom
    registrationEndDateUntil: $registrationEndDateUntil
    sortBy: $sortBy
    sortDesc: $sortDesc
    cupIds: $cupIds
    walletStatuses: $walletStatuses
    useEquipe: $useEquipe
    noncompetition: $noncompetition
    eventCategoryIds: $eventCategoryIds
    profQualificationIds: $profQualificationIds
    countryIds: $countryIds

    isHighlighted: $isHighlighted
    hasTeamCompetitions: $hasTeamCompetitions
    hasChampionshipCompetitions: $hasChampionshipCompetitions

    hasEntries: $hasEntries
    hasAcceptedEntries: $hasAcceptedEntries
    hasCandidacyEntries: $hasCandidacyEntries

    closingSoon: $closingSoon
    recentlyOpened: $recentlyOpened

    noPeopleAssignedInRoleIds: $noPeopleAssignedInRoleIds
    personRoleFilter: $personRoleFilter
  `
};
